import React, {useState} from "react";
import {Col, Row} from "reactstrap";
import {Divider} from "@mui/material";
import ValidateMessages from "../../../../../../../core/models/static/texts/vallidate-messages";
import useIsMounted from "../../../../../../hooks/use-is-mounted";
import Dialog from "../../../../../../components/base/dialog";
import Form from "../../../../../../components/base/form";
import Api from "../../../../../../../core/services/api/api";
import {OutlinedInputForm} from "../../../../../../components/base/input/outlined_input";
import Button from "../../../../../../components/base/button/button";
import PhoneInput from "../../../../../../components/base/input/phone-input";
import {MuiRFF, Yup} from '../../../../../../components/form';

const schema = Yup.object().shape({
    firstName: Yup.string().trim().nullable().required(ValidateMessages.required),
    lastName: Yup.string().trim().nullable().required(ValidateMessages.required),
    email: Yup.string().email(ValidateMessages.incorrect).nullable().required(ValidateMessages.required),
    phone: Yup.string().trim().nullable()
        .required(ValidateMessages.required)
        .phoneNo(ValidateMessages.incorrectType("phone"), 10),
});

const validate = MuiRFF.makeValidate(schema);
const required = MuiRFF.makeRequired(schema);

const AddOperatorModal = ({open, setOpen, onSuccess}) => {
    const isMounted = useIsMounted();

    const [loading, setLoading] = useState(false);

    /**
     * Calls api for adding an operator for the creators company
     * @param values
     */
    const addOperator = (values) => {
        setLoading(true);
        Api.createOperator(values).then((response) => {
            if (!isMounted()) return;
            if (response?.resultFlag) {
                onSuccess(typeof response?.data !== 'object' ? null : response.data);
                setOpen(false);
            }
            setLoading(false);
        })
    }

    const colClass = 'px-3 mb-4';
    return (
        <Dialog
            open={open}
            setOpen={setOpen}
            loading={loading}
        >
            <Row className='no-gutters align-items-center w-100 transition'>
                <Row xs={12} className='no-gutters justify-content-center m-3 w-100'>
                    <p className='text-lg text-color-1 font-weight-semi-bold text-center'>
                        Add Operator
                    </p>
                </Row>
                <Divider className='divider'/>
                <div className='my-3 w-100'/>
                <Form
                    className='w-100'
                    onSubmit={addOperator}
                    validate={validate}
                    initialValues={{}}
                    render={({submitting, values, form}) => {
                        return (
                            <Row className='no-gutters justify-content-around w-100'>
                                <Row className='no-gutters justify-content-around w-100'>
                                    <Col xs={6} className={colClass}>
                                        <OutlinedInputForm
                                            label={'First Name'}

                                            name={'firstName'}
                                            type={'text'}
                                            required={required.firstName}
                                            value={values?.firstName ?? ''}
                                            onChange={(e) => form.change(e.target.name, e.target.value)}
                                        />
                                    </Col>
                                    <Col xs={6} className={colClass}>
                                        <OutlinedInputForm
                                            label={'Last Name'}

                                            name={'lastName'}
                                            type={'text'}
                                            required={required.lastName}
                                            value={values?.lastName ?? ''}
                                            onChange={(e) => form.change(e.target.name, e.target.value)}
                                        />
                                    </Col>
                                    <Col xs={12} className={colClass}>
                                        <OutlinedInputForm
                                            label={'Email'}

                                            name={'email'}
                                            type={'text'}
                                            required={required.email}
                                            value={values?.email ?? ''}
                                            onChange={(e) => form.change(e.target.name, e.target.value)}
                                        />
                                    </Col>
                                    <Col xs={12} className={colClass}>
                                        <PhoneInput
                                            form={form}
                                            label={'Phone Number'}
                                            aria-label={'Phone Number of the operator'}
                                            name={'phone'}
                                            required={required.phone}
                                            value={values?.phone ?? ''}
                                        />
                                    </Col>
                                </Row>
                                <div className='my-1 w-100'/>
                                <Divider className='divider'/>
                                <Row className='no-gutters justify-content-between align-items-start w-100'>
                                    <Button
                                        disabled={!open || submitting || loading}
                                        variant={'dialog'}
                                        color={'primary'}
                                        onClick={() => setOpen(false)}
                                        borderRadius={'0 8px 0 8px'}
                                    >
                                        {submitting || loading ? 'loading...' : 'Close'}
                                    </Button>
                                    <Button
                                        disabled={!open || submitting || loading}
                                        variant={'dialog'}
                                        color={'primary'}
                                        type={'submit'}
                                        borderRadius={'8px 0 8px 0'}
                                    >
                                        {submitting || loading ? 'loading...' : 'Add operator'}
                                    </Button>
                                </Row>
                            </Row>
                        );
                    }}
                />
            </Row>
        </Dialog>
    );
}

export default AddOperatorModal;
